module.exports = __webpack_public_path__ + "img/verify-for-admin-in-portal-en.7b81ad8.png";